import React from 'react';
import { connect as connectFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import feedbackIcon from '../../images/key-features-icons/ic_feedback.svg';

import FaqAccordion from './FaqAccordion';
import * as componentStyles from './FaqSection.style';

const FAQ_ITEMS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

const FaqSection = ({ styles }) => (
    <section className={styles.wrapper}>
        <div className={styles.inner}>
            <div className={styles.sectionHeader}>
                <img src={feedbackIcon} alt="" role="presentation" className={styles.icon} />
                <h2 className={styles.sectionTitle}>
                    <FormattedMessage id="faq.section.title" />
                </h2>
            </div>
            <div className={styles.list}>
                {FAQ_ITEMS.map(n => (
                    <FaqAccordion key={n} questionId={`faq.items.${n}.question`} answerId={`faq.items.${n}.answer`} />
                ))}
            </div>
        </div>
    </section>
);

export default connectFela(componentStyles)(FaqSection);
